import React from 'react';
import { BRAND } from './theme';

// Construction Market logo — inline SVG mark + wordmark (self-contained; no asset needed).
// The upstream Frame_1.png wasn't present in the repo; drop it into /public and swap the
// <svg> for <img src="/Frame_1.png" .../> here if/when you want the exact artwork.
// `dark` = white wordmark for placement on ink/dark headers.
export default function BrandLogo({ height = 26, dark = false, showWords = true }) {
  const wordColor = dark ? '#FFFFFF' : BRAND.ink;
  return (
    <span className="inline-flex items-center" style={{ gap: Math.round(height * 0.34) }}>
      <svg width={height} height={height} viewBox="0 0 32 32" fill="none" aria-label="Construction Market" role="img">
        <rect x="1" y="1" width="30" height="30" rx="7" fill={BRAND.orange} />
        <path d="M6 12 L16 5.5 L26 12" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <rect x="8.5" y="17" width="4" height="7" rx="1" fill="#FFFFFF" />
        <rect x="14" y="14" width="4" height="10" rx="1" fill="#FFFFFF" />
        <rect x="19.5" y="11" width="4" height="13" rx="1" fill="#FFFFFF" />
      </svg>
      {showWords && (
        <span className="whitespace-nowrap" style={{ color: wordColor, fontWeight: 800, letterSpacing: '-0.01em', lineHeight: 1, fontSize: Math.round(height * 0.5) }}>
          Construction<span style={{ color: BRAND.orange }}> Market</span>
        </span>
      )}
    </span>
  );
}
